// extracted by mini-css-extract-plugin
module.exports = {"Zoom":"Zoom--NY_4Y"};